<template>
  <div>
    <footer class="bg-blue text-white py-8 mt-10">
      <div class="container mx-auto px-4 sm:px-6 lg:px-32">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <!-- Section 1: Account Access -->
          <div>
            <h2 class="text-xl font-bold mb-4">Accès rapide dans votre compte</h2>
            <div class="flex items-start space-x-3">
              <svg class="h-8 w-8 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
              <p class="text-sm sm:text-base">
                <button @click="goToCommand" class="underline    cursor-pointer">Suivez votre commande</button>,
                <button @click="goToFacturation" class="underline    cursor-pointer">Payez les factures</button> ou
                <a href="/retour" class="underline    cursor-pointer">Retournez un article</a>.
              </p>
            </div>
          </div>

          <!-- Section 2: Business with Scap -->
          <div>
            <h2 class="text-xl font-bold mb-4">Faire des affaires avec Scap</h2>
            <div class="flex items-center space-x-3">
              <svg class="h-8 w-8 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
              <a href="/patnersPlatform" class="text-sm sm:text-base underline    cursor-pointer">Vendre sur scap.ma</a>
            </div>
          </div>

          <!-- Section 3: Customer Support -->
          <div>
            <h2 class="text-xl font-bold mb-4">Avez-vous besoin de nous ?</h2>
            <div class="flex items-start space-x-3">
              <svg version="1.1" viewBox="0 0 24 24" aria-hidden="true" class="h-8 w-8 flex-shrink-0">
                <path d="M22.52 14A9.07 9.07 0 106 7.23a8.43 8.43 0 00-3.51 2.13 8.6 8.6 0 00-1 10.92l-.71 2.93 2.93-.73a8.58 8.58 0 0010.93-1 8.62 8.62 0 002.12-3.58 8.5 8.5 0 003.12-1.27l2.74.69a.69.69 0 00.44-.15.4.4 0 00.15-.44zm-8.62 6.8a7.57 7.57 0 01-9.65.89l-.34-.25-1.81.39.44-1.76-.25-.34a7.58 7.58 0 1111.61 1.08zm6-5.19a.38.38 0 00-.4.05 7.74 7.74 0 01-2.5 1.17 8.55 8.55 0 00-2.37-7.47A8.67 8.67 0 007.12 7 7.81 7.81 0 019.2 3.33a8.16 8.16 0 0111.46 0 8.1 8.1 0 01.93 10.29.5.5 0 00-.05.39l.46 2.15zm-5.9-.28a5.2 5.2 0 01-5.29 5.14 5.24 5.24 0 01-5.29-5.14.47.47 0 01.49-.49.47.47 0 01.49.49 4.25 4.25 0 004.31 4.16A4.25 4.25 0 0013 15.33a.5.5 0 011 0z" fill="currentColor"></path>
              </svg>
              <p class="text-sm sm:text-base">
                Nous vous aidons avec plaisir.
                <a href="/contacter" class="underline    cursor-pointer">Notre service client</a> est ouvert jour et nuit.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "FootBar",
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    goToCommand() {
      if (this.$store.state.clientId) {
        this.$router.push('/command');
      } else {
        this.$router.push('/logineC');
      }
    },
    goToFacturation() {
      if (this.$store.state.clientId) {
        this.$router.push('/factureC');
      } else {
        this.$router.push('/logineC');
      }
    },
  },
};
</script>